exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer__aczY {\n    padding: 0 20px;\n}\n\n.divition_1p97s {\n    margin: 10px 0;\n    border-top: 5px solid #040404;\n}\n\n.infoContainer__aczY > p {\n    text-align: center;\n    font-style: italic;\n}\n\n.infoContainer__aczY > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.tableContainer_1u0Jd {\n    padding: 20px 0 0 0;\n}\n\n.advertisement_1eN-U {\n    text-align: center;\n    font-style: italic;\n    font-weight: 800;\n}\n\n.gapSection11_3Dj89 {\n    height: 380px;\n}\n", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer__aczY",
	"divition": "divition_1p97s",
	"tableContainer": "tableContainer_1u0Jd",
	"advertisement": "advertisement_1eN-U",
	"gapSection11": "gapSection11_3Dj89"
};